<div
  class="modal-overlay"
  tabindex="0"
  role="dialog"
  aria-modal="true"
  (click)="close()"
  (keydown.escape)="close()"
>
  <div
    class="modal-content"
    tabindex="-1"
    role="document"
    (click)="$event.stopPropagation()"
    (keydown.escape)="close()"
  >
    <!-- Header -->
    <div class="modal-header">
      <button type="button" class="close-btn" (click)="close()" aria-label="Fermer">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <!-- Contenu -->
    @if (saloon) {
    <div class="saloon-info">
      <!-- ─── EVENT INFO (optionnel) ─── -->
      @if (eventInfo) { @if (eventInfo.imageUrl || saloon.imgUrl) {
      <div class="saloon-hero">
        <img
          [src]="eventInfo.imageUrl || saloon.imgUrl"
          [alt]="eventInfo.imageUrl ? eventInfo.title : saloon.name"
          class="saloon-image"
          loading="lazy"
        />
        <div class="saloon-hero-gradient"></div>
        @if (typeLabel) {
        <span class="saloon-type-badge">{{ typeLabel }}</span>
        }
      </div>
      }

      <div class="event-modal-tabs" role="tablist" aria-label="Détails événement et saloon">
        <button
          type="button"
          class="event-modal-tab"
          role="tab"
          [class.active]="activeEventModalTab === 'event'"
          [attr.aria-selected]="activeEventModalTab === 'event'"
          (click)="setEventModalTab('event')"
        >
          Événement
        </button>
        <button
          type="button"
          class="event-modal-tab"
          role="tab"
          [class.active]="activeEventModalTab === 'saloon'"
          [attr.aria-selected]="activeEventModalTab === 'saloon'"
          (click)="setEventModalTab('saloon')"
        >
          Saloon
        </button>
      </div>

      <!-- Carte événement -->
      @if (activeEventModalTab === 'event') {
      <div class="event-card">
        <div class="event-card-accent"></div>
        <div class="event-card-body">
          <span class="event-card-eyebrow">Événement</span>
          <div class="event-card-header">
            <h3 class="event-card-title">{{ eventInfo.title }}</h3>
            @if (eventInfo.subTitle) {
            <p class="event-card-subtitle">{{ eventInfo.subTitle }}</p>
            }
          </div>
          <div class="event-card-chips">
            <span class="event-chip">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
              </svg>
              <span>
                <span class="event-chip-label">Date</span>
                <strong>{{ eventInfo.startDateTime | date : 'EEE d MMM yyyy' : '' : 'fr' }}</strong>
              </span>
            </span>
            <span class="event-chip">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
              </svg>
              <span>
                <span class="event-chip-label">Heure</span>
                <strong>{{ eventInfo.startDateTime | date : 'HH:mm' : '' : 'fr' }}</strong>
              </span>
            </span>
          </div>
          @if (eventInfo.description) {
          <p class="event-card-description">{{ eventInfo.description }}</p>
          }
          <!-- Bouton intéressé -->
          <div class="event-card-footer">
            <button
              type="button"
              class="event-interest-btn"
              [class.interested]="eventInfo.isInterested"
              (click)="onToggleInterest()"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                [attr.fill]="eventInfo.isInterested ? 'currentColor' : 'none'"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polygon
                  points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
                />
              </svg>
              <span>{{ eventInfo.isInterested ? 'Intéressé(e)' : "Ça m'intéresse" }}</span>
              @if (eventInfo.interestedCount) {
              <span class="event-interest-count">{{ eventInfo.interestedCount }}</span>
              }
            </button>
          </div>
        </div>
      </div>
      } } @else {
      <!-- Image saloon standard (sans événement) -->
      @if (saloon.imgUrl) {
      <div class="saloon-hero">
        <img [src]="saloon.imgUrl" [alt]="saloon.name" class="saloon-image" loading="lazy" />
        <div class="saloon-hero-gradient"></div>
        @if (typeLabel) {
        <span class="saloon-type-badge">{{ typeLabel }}</span>
        }
      </div>
      } } @if (!eventInfo || activeEventModalTab === 'saloon') {
      <section class="saloon-details">
        <div class="saloon-title-row">
          <div class="saloon-title-copy">
            <!-- Nom du saloon -->
            <h2 class="saloon-name" [class.saloon-name-small]="eventInfo">{{ saloon.name }}</h2>
          </div>
        </div>

        <!-- Adresse -->
        @if (saloon.address || saloon.city) {
        <div class="saloon-address-card">
          <span class="saloon-address-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
              <circle cx="12" cy="10" r="3" />
            </svg>
          </span>
          <div>
            <span class="saloon-address-label">Adresse</span>
            @if (saloon.address) {
            <p class="saloon-address">{{ saloon.address }}</p>
            } @if (saloon.city) {
            <p class="saloon-city">{{ saloon.city }}</p>
            }
          </div>
        </div>
        }

        <div class="saloon-stats">
          <!-- Présence -->
          <div class="saloon-stat">
            <span class="saloon-stat-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
            </span>
            <span>
              <span class="saloon-stat-label">Visiteurs</span>
              <span class="saloon-stat-value">
                @if (connectedCount === 0) { Aucun visiteur } @else {
                {{ connectedCount }} connecté{{ connectedCount > 1 ? 's' : '' }}
                }
              </span>
            </span>
          </div>

          <!-- Distance -->
          @if (distanceMessage) {
          <div
            class="saloon-stat distance-stat"
            [class.can-enter]="!isTooFar"
            [class.too-far]="isTooFar"
          >
            <span class="saloon-stat-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="m12 2 7 19-7-4-7 4 7-19Z" />
              </svg>
            </span>
            <span>
              <span class="saloon-stat-label">Distance</span>
              <span class="saloon-stat-value">{{ distanceMessage }}</span>
            </span>
          </div>
          }
        </div>

        @if (isTooFar) {
        <p class="distance-warning">Rapprochez-vous pour entrer</p>
        }
      </section>

      <!-- Message d'erreur -->
      @if (errorMessage) {
      <div class="error-message">
        {{ errorMessage }}
      </div>
      }

      <!-- Boutons d'action -->
      <div class="actions">
        @if (isInThisSaloon) {
        <!-- Déjà dans ce saloon -->
        <button type="button" class="btn btn-primary" (click)="goToSaloon()">
          Revenir dans ce saloon
        </button>
        <button type="button" class="btn btn-leave" (click)="leaveSaloon()" [disabled]="isLoading">
          @if (isLoading) {
          <span class="spinner"></span>
          } @else { Quitter ce saloon }
        </button>
        } @else if (hasSessionElsewhere) {
        <!-- Session active dans un autre saloon -->
        <div class="session-switch-panel">
          <div class="session-warning">
            <span class="session-warning-icon" aria-hidden="true">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <circle cx="12" cy="12" r="10" />
                <path d="M12 8v5" />
                <path d="M12 16h.01" />
              </svg>
            </span>
            <span>
              <span class="session-warning-label">Saloon actif</span>
              <span class="session-warning-text">
                Vous êtes actuellement dans {{ activeSession?.saloonName }}.
              </span>
            </span>
          </div>

          <button type="button" class="btn btn-primary" (click)="goToSaloon()">
            Revenir dans {{ activeSession?.saloonName }}
          </button>
          <button
            type="button"
            class="btn btn-leave"
            (click)="leaveSaloon()"
            [disabled]="isLoading"
          >
            @if (isLoading) {
            <span class="spinner"></span>
            } @else { Quitter {{ activeSession?.saloonName }}
            }
          </button>
        </div>
        } @else {
        <!-- Peut rejoindre -->
        @if (!isLocationGranted && !canJoinWithoutLocation) {
        <div class="error-message">
          {{ locationStatusMessage }}
        </div>
        <div class="location-actions">
          <button type="button" class="btn btn-primary" (click)="requestGeolocation()">
            Activer la localisation
          </button>
          @if (isLocationBlocked) {
          <button type="button" class="btn btn-secondary" (click)="openLocationSettings()">
            Ouvrir les réglages
          </button>
          }
        </div>
        }
        <button
          type="button"
          class="btn btn-primary"
          (click)="joinSaloon()"
          [disabled]="isLoading || isTooFar || (!isLocationGranted && !canJoinWithoutLocation)"
        >
          @if (isLoading) {
          <span class="spinner"></span>
          } @else { Entrer dans ce saloon }
        </button>
        }
      </div>
      }
    </div>
    }
  </div>
</div>

<!-- Modal de confirmation de sortie -->
<app-confirm-leave-modal
  [isOpen]="showConfirmLeaveModal"
  [isPremium]="isPremium"
  [saloonName]="activeSession?.saloonName || ''"
  (confirmed)="onLeaveConfirmed()"
  (cancelled)="closeConfirmLeaveModal()"
/>
